export default __webpack_public_path__ + "static/media/onboarding.e8f21d06.jpg";